import { log } from '@shared/log.browser.ts';
import tracking from '@shared/tracking/Tracking.browser.ts';
import type { EntryRuleTracking } from '@tilelist/application/ports/EntryRuleTracking.ts';

type EntryRuleTrackingGateway = Pick<typeof tracking, 'addToPageImpression'>;

export function createEntryRuleTracking(gateway: EntryRuleTrackingGateway = tracking): EntryRuleTracking {
    return {
        trackEntryRule(entryRule) {
            log.debug(`trackEntryRule: ${entryRule}`);
            gateway.addToPageImpression({ 'wk.san_EntrySelectionRule': entryRule });
        },
    };
}
